import Vapi from "vuex-rest-api";

const ranking = new Vapi({
  // baseURL: "http://54.146.131.152:8082/api",
  baseURL: "https://copesa.acunaviera.com/api",
  queryParams: true,
  state: {
    trophies: [],
    primes: [],
    positions: [],
    readytrophies: false,
    readyprimes: false,
    readypositions: false,
  },
})
  .get({
    action: "getTrophies",
    property: "trophies",
    path: "/trophies",
    onSuccess: (state, payload, axios, { params, data }) => {
      console.log('success trophies', payload)
      state.trophies = payload.data
      state.readytrophies = true
    },
    onError: (state, error, axios, { params, data }) => {
      console.log(`Oops, there was following error: ${error}`)
      console.log(`Axios: ${axios}`)
      // if you set the onError function you have to set the state manually
      state.trophies = []
    }
  })
  .get({
    action: "getPrimes",
    property: "primes",
    path: "/primes",
    onSuccess: (state, payload, axios, { params, data }) => {
      console.log('success primes')
      state.primes = payload.data
      state.readyprimes = true
    },
    onError: (state, error, axios, { params, data }) => {
      console.log(`Oops, there was following error: ${error}`)
      console.log(`Axios: ${axios}`)
      // if you set the onError function you have to set the state manually
      state.primes = []
    }
  })
  .get({
    action: "getPositions",
    property: "positions",
    path: "/positions",
    onSuccess: (state, payload, axios, { params, data }) => {
      console.log('success positions')
      state.positions = payload.data
      state.readypositions = true
    },
    onError: (state, error, axios, { params, data }) => {
      console.log(`Oops, there was following error: ${error}`)
      console.log(`Axios: ${axios}`)
      // if you set the onError function you have to set the state manually
      state.positions = []
    }
  })
  .getStore();

export default ranking;
